import React from 'react';
import { Link } from 'react-router-dom';
import SearchBar from '../components/SearchBar';

const NotFoundPage = () => {
  return (
    <div className="main-content-container not-found-page">
      <div className="not-found-container">
        {/* Icona moderna 404 */}
        <div className="not-found-icon">
          <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
            <circle cx="100" cy="100" r="80" fill="none" stroke="#e2e8f0" strokeWidth="2"/>
            <text x="100" y="110" textAnchor="middle" fontSize="48" fontWeight="bold" fill="#c93249">404</text>
          </svg>
        </div>

        {/* Testo della pagina */}
        <h1 className="not-found-title">Pagina non trovata</h1>
        <p className="not-found-description">
          Sembra che la pagina che stai cercando non esista o sia stata rimossa. 
          Prova a cercare un altro prodotto o torna alla homepage.
        </p>

        {/* Barra di ricerca */}
        <div className="not-found-search">
          <SearchBar />
        </div>

        {/* Link per tornare alla homepage */}
        <Link to="/" className="not-found-home-btn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <polyline points="9,22 9,12 15,12 15,22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Torna alla homepage
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
